import e from"./Breadcrumb.vue_vue&type=script&lang.js";import{render as r}from"./Breadcrumb.vue_vue&type=template&id=4ed27d54&lang.js";e.render=r;export default e;
//# sourceMappingURL=Breadcrumb.vue.js.map
